import React from 'react'

const S2_about = () => {
  return (
<div  className='S2_about'>
<div className="contabiner">
    <div className="contant">
        <h3>
                About WhitPooL. We believe the best experience always wins          
        </h3>          
              
    </div>          
          
          
          
          
          
          
</div>      
</div>
  )
}

export default S2_about